import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {map, startWith} from 'rxjs/operators';
import {SharedService} from '../../../services/shared.service';
import {StorageService} from '../../../services/storage.service';

@Component({
  selector: 'app-cell-editor-tags',
  templateUrl: './cell-editor-tags.component.html',
  styleUrls: ['./cell-editor-tags.component.scss']
})
export class CellEditorTagsComponent implements OnInit {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl('');
  filteredFruits: Observable<any[]> | undefined;
  tags: any = [];
  originalTags: any = [];
  allTags: any[] = [];

  // @ts-ignore
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  private params: any;
  constructor(
    private storageService: StorageService
  ) {
    this.allTags = storageService.tags;
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => (fruit ? this._filter(fruit) : this.allTags.slice(0, 500))),
    );
  }

  ngOnInit(): void {
    console.log('this.params.api.getEditingCells()', this.params.api.getEditingCells());
  }

  test() {
    console.log('tags', this.tags);
  }

  save() {
    // this.params.data.tags = [];
    this.params.stopEditing();
    console.log('this.params.api', this.params);
  }

  cancel(): void {
    this.tags = this.originalTags;
    this.params.stopEditing();
  }

  agInit(params: any): void {
    this.params = params;
    // this.tags = params.data.tags;
    let tagList = [];

    if (params.data.tags) {
      for (const tag of params.data.tags) {
        const name = this.storageService.tagMap.get(tag._id);
        if (name) {
          tagList.push({ _id: tag._id, name });
        }
      }
    }

    this.tags = structuredClone(tagList);
    this.originalTags = structuredClone(tagList);
    // let foo = this.storageService.tags.map(t => t.tag_id === params.data.tags.map((x: any) => x.tag_id));
    console.log('=-=--=', tagList);
    console.log('agInit');
    // console.log('CellEditorTagsComponent agInit', params);
  }

  getValue(): any {
    console.log('getValue');
    // console.log('this.params', this.params);
    // this.params.data.shopify_sync = true;
    console.log('this.tags', this.tags);
    return this.tags;
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.tags.push(value);
    }

    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }

  remove(tag: string): void {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log('selected', event);
    this.tags.push(event.option.value);
    // @ts-ignore
    this.tagInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  private _filter(value: any): string[] {
    console.log('_filter');
    const filterValue = value.name ? value.name.toLowerCase() : value.toLowerCase()
    // console.log('12filterValue', this.allTags.filter(tag => tag.name.toLowerCase().includes(filterValue)));
    const filtered = this.allTags.filter(tag => tag.name.toLowerCase().includes(filterValue));
  // .slice(0, 30);
    console.log('tags', this.tags);
    console.log('filtered', filtered);
    const result = [];

    for (const fTag of filtered) {
      for (const tag of this.tags) {

      }
    }
    const existTagIds = this.tags.map((tag: any) => tag._id);
    for (const fTag of filtered) {
      if (existTagIds.includes(fTag._id) === false) {
        result.push(fTag);
      }
    }

    // for (const tag of this.tags) {
    //   for (const fTag of filtered) {
    //     if (tag._id !== fTag._id) {
    //       result.push(fTag);
    //     }
    //   }
    //   // if (filtered.includes((x: any) => x._id !== tag._id)) {
    //   //   result.push(tag);
    //   // }
    // }
    // return filtered;
    return result.slice(0, 500);
  }
}
